<template>
    <w-dialog
        :model-value="tambahPelarasan"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width"
        title-class="primary-light1--bg white"
    >
        <w-form @success="submitPelarasan()">
            <w-flex class="pa6" column :gap="3">
                <w-input
                    type="number"
                    v-model="addCukaiPelarasan.tahun"
                    label="Tahun"
                    :validators="[validators.required]"
                    disabled
                >
                </w-input>
                <z-lookup
                    :label="'Kod Hasil'"
                    :url="apiBaseUrl + '/akaun'"
                    :sort="false"
                    :cache="false"
                    v-model="addCukaiPelarasan.akaun_id"
                    :validators="[validators.required]"
                />
                <w-input v-model="addCukaiPelarasan.amaun_debit" type="number">
                    Amaun Debit (RM)
                </w-input>
                <w-input v-model="addCukaiPelarasan.amaun_kredit" type="number">
                    Amaun Kredit (RM)
                </w-input>
                <w-textarea v-model="addCukaiPelarasan.ulasan" :validators="[validators.required]">
                    Mesej/Catatan Pelarasan
                </w-textarea>
            </w-flex>
            <w-flex class="px6" v-if="$zutil.can('Kemaskini Hakmilik')">
                <div class="spacer" />
                <w-button
                    :loading="searching"
                    text
                    @click="tambahPelarasan=false"
                >
                    Batal
                </w-button>
                <w-button :loading="searching" class="ml3" type="submit"> Simpan </w-button>
            </w-flex>
        </w-form>
        <w-alert error outline v-if="error">{{ error }}</w-alert>
    </w-dialog>
</template>

<script>
import WaveUI from "wave-ui";
import moment from "moment";


export default{
    props:{
        tambahPelarasan:Boolean,
        addCukaiPelarasan:[Array,Object],
        searching:Boolean,
        submitPelarasan:Function,
    },
    data(){
        return{
            waveui: new WaveUI(),
            valid :null,
            validators: {
               required: (value) => !!value || "Sila Isi Ruangan Ini",
            },
            apiBaseUrl : process.env.MIX_API_BASE_URL,
            loading:false,
            dialog :{
                fullscreen: false,
                // persistent: true,
                persistentNoAnimation: false,
                width: "50%",
            },
            error:null,
        }
    },
    methods:{

    }
}

</script>
